import React, { Fragment } from 'react';

export default ({ order, className }) => <p className={className}>
	{Object.keys(order.address).map(key => order.address[key] && <Fragment key={key}>
		{order.address[key]}<br />
	</Fragment>)}
</p>;
